import React, { useContext } from 'react'
import { ClickableItemCard } from '@Components/Cards/ClickableItemCard'
import clsx from 'clsx'
import { Link, useOutletContext } from 'react-router'
import { CardWithHeader } from '@Components/Tables/CardResults/card-with-header'
import { SuggestedMatch } from '@Entities/matching/suggested-match'
import MatchSearchResultItemHeader from '@Components/MatchComponents/v2/MatchSearchResultItem/match-search-result-item-header'
import StatusComponent from '@Components/Status'
import './index.scss'
import day from 'dayjs'
import { StoresContext } from '@App/contexts'
import Navigation from '@App/navigation'

export const MatchSearchResultItem: CardWithHeader<SuggestedMatch> = (props: SuggestedMatch) => {
    const { rightsholderStore, songwriterStore } = useContext(StoresContext)
    const { isSongwriterHub } = useOutletContext<{ isSongwriterHub: boolean }>()

    let path: string
    if (isSongwriterHub) {
        path = Navigation.songwriter.matchingHistoryViewSubmission(
            songwriterStore.currentSongwriterId,
            props.suggestedMatchId
        )
    } else {
        path = Navigation.rightholder.matchClaim.matchUsage(
            rightsholderStore.currentRightsholderId,
            props.suggestedMatchId
        )
    }

    const recordingGroupCount =
        props.recordingGroupsSubmitted +
        props.recordingGroupsApproved +
        props.recordingGroupsRejected +
        props.recordingGroupsSuperseded

    return (
        <ClickableItemCard className={clsx('suggested-match-item')} handleOnClick={() => {}} path={path}>
            <div className="small-portal-column submission-date">
                {day(props.submissionTimestamp, 'YYYY-MM-DD HH:mm:ss ZZ')
                    .toDate()
                    .toLocaleString('default', { month: 'short', day: 'numeric', year: 'numeric' })}
            </div>
            <div className="small-portal-column  recording-groups-count">{recordingGroupCount}</div>
            <div className="small-portal-column work-title">
                <Link
                    to={path}
                    className="title-link"
                    onClick={(e) => {
                        e.stopPropagation()
                    }}
                    onMouseDown={(e) => {
                        e.stopPropagation()
                    }}
                >
                    {props.workTitle}
                </Link>
            </div>

            <div className="small-portal-column song-code">{props.currentSongCode}</div>
            <div className="writers">{props.workWriters && props.workWriters.split('|').join(', ')}</div>
            <StatusComponent status={props.submissionStatus} />
        </ClickableItemCard>
    )
}

MatchSearchResultItem.headerType = MatchSearchResultItemHeader

export default MatchSearchResultItem
